class ZoomImage extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.zoom-image__inner');
    this.image = this.querySelector('img');
    this.isZoomed = false;
    this.scale = this.getAttribute('scale') || 2.5;

    this.init();
  }

  init() {
    this.container.addEventListener('click', (e) => this.toggleZoom(e));
    this.container.addEventListener('mousemove', (e) => this.handleMouseMove(e));
    this.container.addEventListener('mouseleave', () => this.resetZoom());
  }

  toggleZoom(e) {
    this.isZoomed = !this.isZoomed;
    this.container.classList.toggle('is-active', this.isZoomed);

    if (this.isZoomed) {
      // 1. Calculate origin first so it doesn't 'jump' from center
      this.updateOrigin(e);
      // 2. Apply scale
      this.image.style.transform = `scale(${this.scale})`;
    } else {
      this.resetZoom();
    }
  }

  handleMouseMove(e) {
    if (!this.isZoomed) return;
    // Use requestAnimationFrame to sync with browser paint cycles
    requestAnimationFrame(() => this.updateOrigin(e));
  }

  updateOrigin(e) {
    const rect = this.container.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    // We set the transition to 'none' for the origin so it follows the mouse instantly
    // but keep a slight transition for the transform (scale) if desired.
    this.image.style.transition = 'transform 0.3s ease-out, transform-origin 0s';
    this.image.style.transformOrigin = `${x}% ${y}%`;
  }

  resetZoom() {
    this.isZoomed = false;
    this.container.classList.remove('is-active');

    // Smoothly animate back to center
    this.image.style.transition = 'transform 0.3s ease-out, transform-origin 0.3s ease-out';
    this.image.style.transform = 'scale(1)';
    this.image.style.transformOrigin = 'center center';
  }
}

customElements.define('zoom-image', ZoomImage);